import { put, call, select, takeEvery } from 'redux-saga/effects';

import { formatError } from '../../../libs';
import freightsAPI from '../../api/freights';
import { Creators as FreightsCreators, Types } from '../../reducers/freights';
import { getCartId, setCustomerCep, getCustomerCep } from '../../utils/cookies';
import getState from '../../utils/getState';

function* cartFreightRequest({ cep, params }) {
  try {
    const {
      cart,
      customer,
      app: { asPath, config = {} },
    } = yield select(getState);

    const isCheckout = asPath.includes('checkout');
    const cartId = cart.id || customer.cartId || getCartId();
    const { siteId, domain } = config;

    let validCep = cep;

    if (isCheckout) {
      if (!validCep) {
        throw 'Selecione e/ou cadastre um endereço para calcular frete.';
      }
    } else if (!validCep) {
      validCep = getCustomerCep(domain);
    }

    if (!validCep || validCep.length < 8) {
      throw new Error('Cep inválido');
    }

    validCep = validCep.replace(/\D/g, '').replace(/(\d{5})(\d{3})/, '$1-$2');

    const data = yield call(freightsAPI.getFreights, cartId, { cep: validCep, ...params }, siteId);

    setCustomerCep(validCep, domain);

    yield put(FreightsCreators.cartFreightSuccess(data, params?.idSeller));
  } catch (error) {
    const idSeller = params?.idSeller;
    const formattedError = { ...formatError(error), cart: true };

    yield put(FreightsCreators.cartFreightFailed(idSeller ? { [idSeller]: formattedError } : formattedError, idSeller));
  }
}

export default function* watch() {
  yield takeEvery(Types.CART_FREIGHT_REQUEST, cartFreightRequest);
}
